import { generateRandomId } from "../../../utils/session";
import AUTOMATION_BLOCK_TYPES from "./AutomationBlockTypes";

export const ActionPalette = [
    {
        group: "Interactions",
        enabled: true,
        items: [
            {
                name: "Fallback",
                id: AUTOMATION_BLOCK_TYPES.FALLBACK,
            },
            {
                name: "Timeout",
                id: AUTOMATION_BLOCK_TYPES.TIMEOUT,
            },
            { name: "Filter", id: AUTOMATION_BLOCK_TYPES.FILTER },
            { name: "Flow", id: AUTOMATION_BLOCK_TYPES.FLOW },
            { id: AUTOMATION_BLOCK_TYPES.SLEEP },
            { id: AUTOMATION_BLOCK_TYPES.NOOP },
            { id: AUTOMATION_BLOCK_TYPES.CATCH_WEBHOOK },
            { id: AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION },
            { id: AUTOMATION_BLOCK_TYPES.CREATE_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.UPDATE_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CONTACTS },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CHATS },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CHAT },
            { id: AUTOMATION_BLOCK_TYPES.WAIT_FOR },
        ],
    },
    {
        group: "Loop Actions",
        enabled: true,
        items: [
            { name: "Loop", id: AUTOMATION_BLOCK_TYPES.LOOP },
            { name: "Loop Next", id: AUTOMATION_BLOCK_TYPES.LOOP_NEXT },
            { name: "Loop Break", id: AUTOMATION_BLOCK_TYPES.LOOP_BREAK },
            { name: "Loop Continue", id: AUTOMATION_BLOCK_TYPES.LOOP_CONTINUE },
            { name: "Loop Finish", id: AUTOMATION_BLOCK_TYPES.LOOP_FINISH },
        ],
    },
    {
        group: "Data Formatters",
        enabled: true,
        items: [
            { name: "String Formatter", id: AUTOMATION_BLOCK_TYPES.STRING_FORMAT },
            { name: "Number Formatter", id: AUTOMATION_BLOCK_TYPES.NUMBER_FORMAT },
            { name: "Date Formatter", id: AUTOMATION_BLOCK_TYPES.DATE_FORMAT },
        ],
    },
    {
        group: "File Actions",
        enabled: true,
        items: [{ name: "CSV Records", id: AUTOMATION_BLOCK_TYPES.RECORDS_FROM_CSV }],
    },
    {
        group: "Actions",
        enabled: true,
        items: [
            { name: "Go To Step", id: AUTOMATION_BLOCK_TYPES.GO_TO_STEP },
            { name: "Add To Segment", id: AUTOMATION_BLOCK_TYPES.ADD_TO_SEGMENT },
            { name: "Remove From Segment", id: AUTOMATION_BLOCK_TYPES.REMOVE_FROM_SEGMENT },
            {
                name: "Webhook",
                id: AUTOMATION_BLOCK_TYPES.WEBHOOK,
            },
            { name: "Set Attribute", id: AUTOMATION_BLOCK_TYPES.SET_ATTRIBUTE },
        ],
    },
    {
        group: "Supsis Actions",
        enabled: true,
        items: [
            { name: "Create Ticket", id: AUTOMATION_BLOCK_TYPES.CREATE_TICKET },
            {
                name: "Transfer Chat",
                id: AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
            },
            {
                name: "Forward to ChatBot",
                id: AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
            },
            { name: "Set Department", id: AUTOMATION_BLOCK_TYPES.SET_DEPARTMENT },
            {
                name: "Send SMS",
                id: AUTOMATION_BLOCK_TYPES.SEND_SMS,
            },
            {
                name: "Send Mail",
                id: AUTOMATION_BLOCK_TYPES.SEND_MAIL,
            },
            {
                name: "Create Event",
                id: AUTOMATION_BLOCK_TYPES.CREATE_EVENT,
            },
            {
                name: "Create Task",
                id: AUTOMATION_BLOCK_TYPES.CREATE_TASK,
            },
            {
                name: "Ban Visitor",
                id: AUTOMATION_BLOCK_TYPES.SUPPRESSION_ADD,
            },
            {
                name: "Unban Visitor",
                id: AUTOMATION_BLOCK_TYPES.SUPPRESSION_REMOVE,
            },
            {
                name: "Create Reservation",
                id: AUTOMATION_BLOCK_TYPES.CREATE_RESERVATION,
            },
            {
                name: "Send Whatsapp Business Message",
                id: AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
            },
        ],
    },
];

export const BlockStyles = {
    START_POINT: { color: "#fff", backgroundColor: "#566e8a" },
    AI_ASSISTANT: { color: "#fff", background: "linear-gradient(162deg,#4b6ae5,#0031f6)" },
    DEFAULT_FALLBACK: { color: "#fff", backgroundColor: "#797b8c" },
    DEFAULT_TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    BOT_RESPONSE: { color: "#647283", backgroundColor: "#f5f5f5" },
    AI_BOT_RESPONSE: { color: "#647283", backgroundColor: "#41ce13" },
    AI_CLASSIFICATION: { color: "#647283", backgroundColor: "#41ce13" },
    FALLBACK: { color: "#ffffff", backgroundColor: "#797b8c" },
    TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    FILTER: { color: "#fff", backgroundColor: "#686ad3" },
    FLOW: { color: "#000", backgroundColor: "#b3d6ff" },
    ATTACHMENT_INPUT: { color: "#647283", backgroundColor: "#E7E4E4" },
    USER_INPUT: { color: "#59687b", backgroundColor: "#c9d3de" },
    GO_TO_STEP: { color: "#000", backgroundColor: "#ffdc67" },
    ADD_TO_SEGMENT: { color: "#22314A", backgroundColor: "#9CCB80" },
    REMOVE_FROM_SEGMENT: { color: "#22314A", backgroundColor: "#F5F5F5" },
    WEBHOOK: { color: "#fff", backgroundColor: "#40455b" },
    SET_ATTRIBUTE: { color: "#fff", backgroundColor: "#6e5b8c" },
    QUESTION: { color: "#000", backgroundColor: "#ffad5c" },
    CLOSE_CHAT: { color: "#000", backgroundColor: "#f5f5f5" },
    CREATE_TICKET: { color: "#ffffff", backgroundColor: "#AD6FE9" },
    TRANSFER_TO_CHATBOT: { color: "#ffffff", backgroundColor: "#ff00ca" },
    TRANSFER_CHAT: { color: "#000", backgroundColor: "#76E394" },
    TAG_CHAT: { color: "#000", backgroundColor: "#EDED67" },
    REMOVE_TAG: { color: "#000", backgroundColor: "#EDED67" },
    SET_DEPARTMENT: { color: "#000", backgroundColor: "#40e6ba" },
    SEND_TRANSCRIPT: { color: "#ffffff", backgroundColor: "#4959DA" },
    SEND_SMS: { color: "#ffffff", backgroundColor: "#4959DA" },
    CREATE_TASK: { color: "#fff", backgroundColor: "#73adc5" },
    SUPPRESSION_ADD: { color: "#fff", backgroundColor: "#9d2126" },
    SUPPRESSION_REMOVE: { color: "#fff", backgroundColor: "#9d2126" },

    GET_LOCATION: { color: "#000", backgroundColor: "#7aa8e0" },
    SUCCESS: { color: "#00C800", backgroundColor: "#fff" },
    FAILURE: { color: "#FF0000", backgroundColor: "#fff" },
    SEND_MAIL: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    CREATE_EVENT: { color: "#ffffff", backgroundColor: "#033c7c" },
    CREATE_RESERVATION: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_SELECT_TIME: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_SELECT_DAY: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_OPEN_URL: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_EVENT_LIST: { color: "#ffffff", backgroundColor: "#235603" },

    SEND_WP_BUSINESS_MESSAGE: { color: "#fff", backgroundColor: "#4ee82f" },
    INSTAGRAM_COMMENT_REPLY: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_DELETE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_SHOW: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_HIDE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: { color: "#fff", backgroundColor: "#833AB4" },
    AI_MENU_FLOW: { color: "#fff", backgroundColor: "#4ee82f" },

    LOOP: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_NEXT: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_BREAK: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_CONTINUE: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_FINISH: { color: "#ffffff", backgroundColor: "#ff00ca" },

    SLEEP: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    NOOP: { color: "#ffffff", backgroundColor: "#73adc5" },
    CATCH_WEBHOOK: { color: "#ffffff", backgroundColor: "#6e5b8c" },
    TERMINATE_AUTOMATION: { color: "#ffffff", backgroundColor: "#9d2126" },
    CREATE_CONTACT: { color: "#ffffff", backgroundColor: "#833AB4" },
    UPDATE_CONTACT: { color: "#ffffff", backgroundColor: "#833AB4" },
    FIND_CONTACTS: { color: "#ffffff", backgroundColor: "#833AB4" },
    FIND_CONTACT: { color: "#ffffff", backgroundColor: "#833AB4" },
    FIND_CHATS: { color: "#ffffff", backgroundColor: "#833AB4" },
    FIND_CHAT: { color: "#ffffff", backgroundColor: "#833AB4" },
    WAIT_FOR: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    STRING_FORMAT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    NUMBER_FORMAT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    DATE_FORMAT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    RECORDS_FROM_CSV: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    MESSAGE_RECEIVED: { color: "#ffffff", backgroundColor: "#ff7a1f" },
};

export const Payloads = {
    GO_TO_STEP: {
        default: {
            blockId: null,
        },
    },
};
